export default __webpack_public_path__ + "static/media/mua-sam.25ba90c0.jpg";